module.exports = __webpack_public_path__ + "img/a4-افقی.7c9f1694.jpg";